const Settings = {
    urls: {
        SettingsUrl: window.SETTINGS_API_URL || DefaultSettings.SETTINGS_API_URL,
        AccountStateUrl: window.ACCOUNT_STATE_URL || DefaultSettings.ACCOUNT_STATE_API_URL,
        BaseIDUrl: '/id/',
    },
    SYNC_TIMEOUT: DefaultSettings.SYNC_TIMEOUT,
    LEAD_SYNC: DefaultSettings.LEAD_SYNC,
    SUBMIT_THROTTLE: DefaultSettings.SUBMIT_THROTTLE,
};

export default Settings;
